import type { FormItemRule } from 'element-plus'
import { useKsI18n } from '@siclop/kstone-vue'

type Translate = ReturnType<typeof useKsI18n>['t']

/**
 * Règles de validation Element Plus courantes, messages traduits.
 *
 * @example
 * const { t } = useKsI18n()
 * const rules: FormRules = { label: [requiredRule(t)], email: [emailRule(t)] }
 */
export function requiredRule(t: Translate, trigger: 'blur' | 'change' = 'blur'): FormItemRule {
  return { required: true, message: t('ksproject.validation.required', 'Ce champ est obligatoire'), trigger }
}

/** Sélection obligatoire d'un identifiant : 0 (« aucun ») est refusé. */
export function requiredIdRule(t: Translate): FormItemRule {
  return {
    required: true,
    trigger: 'change',
    validator: (_rule, value, callback) => {
      if (value === null || value === undefined || value === '' || value === 0) {
        callback(new Error(t('ksproject.validation.required', 'Ce champ est obligatoire')))
      } else callback()
    }
  }
}

export function emailRule(t: Translate): FormItemRule {
  return { type: 'email', message: t('ksproject.validation.email', 'Adresse e-mail invalide'), trigger: 'blur' }
}

export function maxLengthRule(t: Translate, max: number): FormItemRule {
  return { max, message: t('ksproject.validation.maxLength', '{max} caractères au plus', { max }), trigger: 'blur' }
}
